module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sent":"Sent","fail_to_send":"Failed to send.","sending":"Sending..."}}')
  delete Component.options._Ctor
}
